import { PureComponent } from "react";

import { cn } from "@btnet/utilities-core";

import { friendlyDefaultDisplayValue } from "utilities/helpers";

import { BTFormItemAutomatic } from "commonComponents/btWrappers/BTForm/BTForm";
import { CurrencyDisplay } from "commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { type IFooterCellProps } from "commonComponents/utilities/Grid/common/BTGridFooterCell/BTGridFooterCell";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type IPreviewLineItemProps,
    LineItemPreview,
} from "commonComponents/utilities/LineItemContainer/LineItemPreview";
import { GridLineItemColumnType } from "commonComponents/utilities/LineItemContainer/types/LineItem.enums";
import { LineItemColumns } from "commonComponents/utilities/LineItemContainer/types/LineItem.types";
import { ValueDisplay } from "commonComponents/utilities/ValueDisplay/ValueDisplay";

import "./CellImplementations.less";

export interface IReadOnlyCurrencyProps extends IPreviewLineItemProps {
    value: number;
    formClassNames?: string[];
    decimalScale?: number;
    ellipsis?: boolean;
    previewKey?: string;
}

export class ReadOnlyCurrencyCell extends PureComponent<
    IGridCellRenderProps<IReadOnlyCurrencyProps>
> {
    render() {
        const { isInEdit, cellValue, field, onFocus } = this.props;
        if (cellValue === null || cellValue.value === null || cellValue.value === undefined) {
            return null;
        }

        const component = (
            <LineItemPreview
                fieldName="currency"
                addPreviewListener={cellValue?.addPreviewListener}
                render={(preview) => (
                    <CurrencyDisplay
                        value={
                            (preview?.[cellValue.previewKey ?? ""] as number | undefined) ??
                            cellValue.value
                        }
                        data-testid={field.full}
                        decimalScale={cellValue.decimalScale}
                    />
                )}
            />
        );

        if (isInEdit) {
            return (
                <BTFormItemAutomatic
                    id={field.full}
                    className={cn("RightAlignFormLabel", "LineItemCell", cellValue.formClassNames, {
                        ellipsis: cellValue?.ellipsis,
                    })}
                >
                    <div className="ReadOnlyMarginTop" tabIndex={0}>
                        {component}
                    </div>
                </BTFormItemAutomatic>
            );
        }

        return (
            <ValueDisplay
                value={component}
                className={cn("LineItemCell", cellValue.formClassNames, {
                    ellipsis: cellValue?.ellipsis,
                })}
                onFocus={onFocus}
            />
        );
    }
}

export class LineItemCurrencyFooter extends PureComponent<IFooterCellProps> {
    render() {
        const { value, classname, "data-testid": testId } = this.props;

        if (value === null || value === undefined) {
            return friendlyDefaultDisplayValue;
        }

        return <CurrencyDisplay value={value} className={classname} data-testId={testId} />;
    }
}

export const builderCostCellDefaultConfig = () => ({
    id: LineItemColumns.BuilderCost,
    name: "Builder cost",
    jsonKey: "builderCost",
    width: 120.0,
    minWidth: 48,
    ellipsis: true,
    align: "right",
    isSortable: true,
    columnType: GridLineItemColumnType.readOnlyCurrency,
    isFrozen: false,
    isHidden: false,
    Cell: ReadOnlyCurrencyCell,
    FooterCell: LineItemCurrencyFooter,
});
